import ReactComponent from '../app/ReactComponent'
import {Button, Col, Empty, Flex, Image, Row} from 'antd'
import {$t} from '../app'
import onYourOwnIcon from '../gfx/iceland-on-your-own-ico.png'
import {Link, useParams} from 'react-router-dom'
import GParallax from '../components/helpers/GParallax'

// IMAGES
import droneLandscapeImage from '../gfx/DJI_01652@small.jpg'
import {$language} from '../app/Languages'
import CardSanded from '../components/cards/CardSanded'
import VulcanicLandscapeImage from '../gfx/DJI_0149@small.jpg'

export default class GuideOverviewByCategoryPage extends ReactComponent {
  state = {
    loading: true,
    posts: [],
    category: {
      id: null,
      name: '',
      description: '',
      slug: null
    }
  }

  async componentDidMount() {
    const {slug = null} = this.props

    this.scrollToTop()
    this.$app.$theme('dark')

    const {id} = await this.getCategory(slug)

    await this.getPostByCategory(id)

  }

  async getCategory(slug = null) {
    const active_lang = $language().$language()

    const category = (await this.$app.$directus(`categories/`, {
      fields: ['*', {translations: ['name', 'description', 'slug']}, {featured_image: ['*']}],
      filter: {
        translations: {
          slug: {'_eq': slug}
        }
      },
      deep: {
        translations: {
          _filter: {
            languages_code: {'_eq': active_lang}
          }
        }
      },
      meta: 'filter_count'
    }))[0]

    await this.updateState({
      category: {
        id: category.id || null,
        name: category.translations[0].name || '',
        description: category.translations[0].description || '',
        slug: category.translations[0].slug || null,
        featured_image: category.featured_image || null,
      }
    })

    return category
  }

  async getPostByCategory(category_id) {
    const active_lang = $language().$language()

    const data = await this.$app.$directus(`posts`, {
      fields: ['*', {translations: ['name', 'content', 'slug']}, {featured_image: ['*']}],
      filter: {
        category: {'_eq': category_id}
      },
      deep: {
        translations: {
          _filter: {
            languages_code: {'_eq': active_lang}
          }
        }
      }
    })

    const posts = data.map(({translations, ...post}) => ({
      ...translations[0],
      ...post
    }))

    await this.updateState({
      loading: false,
      posts: posts
    })
  }

  render() {
    return (
      <>
        <section className="fullwidth centered">
          <GParallax speed={-3} options={{y: 0}} scrollTrigger={{start: 'top top'}} className="fullwidth-background">
            <Image src={this.state.category.featured_image && `https://admin.trailsoficeandfire.com/assets/${this.state.category.featured_image.id}?quality=30`} preview={false} style={{opacity: 0.6, objectPosition: 'center center'}}/>
          </GParallax>
          <div className="silencer medium"></div>
          <Flex align="center" justify="center">
            <div className="container wide ta-center">
              <h2 className="h1">
                <span className="_grey-primary-text">{this.state.category.name}</span>
              </h2>
              <h5 className="_grey-primary-text dib max-40em mb-4">
                {this.state.category.description}
              </h5>
            </div>
          </Flex>
          <div className="hero-gradient-bottom"></div>
        </section>
        <section>
          <div className="container centered">
            <Flex align="center" justify="center">
              <Row align="middle" justify="center" gutter={[48, 48]} className="mt-3">

                {this.state.posts.map(post => (
                  <>
                    <Col xs={24} sm={12} md={16} lg={18}>
                      <CardSanded
                        image={post.featured_image && `https://admin.trailsoficeandfire.com/assets/${post.featured_image.id}?quality=30`}
                        title={post.name}
                        content={post.description}
                        actions={
                          <Link to={`/online-guide/${this.state.category.slug}/${post.slug}`}>
                            <Button type="primary">
                              <$t _="detail"/>
                            </Button>
                          </Link>
                        }
                      />

                      {/*
                      <div className="card-blurred">
                        <div className="image-wrapper">
                          <Image src={post.featured_image && `https://admin.trailsoficeandfire.com/assets/${post.featured_image.id}?quality=30`} preview={false}/>
                        </div>
                        <div className="mb-3">

                          <h3 className="title">
                            {post.name}
                          </h3>

                          <p>{post.description}</p>

                          <br/>
                          <Link to={`/online-guide/${this.state.category.slug}/${post.slug}`}>
                            <Button type="primary">
                              <$t _="detail"/>
                            </Button>
                          </Link>
                        </div>
                      </div>
                      */}

                    </Col>
                  </>
                ))}

                {!this.state.loading && this.state.posts.length === 0 && (
                  <Empty description={<$t _="no_content"/>}/>
                )}

              </Row>
            </Flex>
          </div>
          <div className="silencer medium"></div>
        </section>
      </>
    )
  }
}

export function GuideOverviewByCategoryPageHOC() {
  const {slug} = useParams()

  return (<GuideOverviewByCategoryPage slug={slug}/>)
}